import React from "react";
import _ from "underscore";
import { Grid, Row, Col } from 'armstrong-react-fix';
import { toDate } from '@travellocal/utils/dateHelpers';

interface Props {
  onChange?: (time: ITimeOfDay) => void;
  time?: ITimeOfDay;
}

interface LocalState {
  time?: ITimeOfDay;
}

export class TimePicker extends React.Component<Props, LocalState> {
  constructor(props: Props) {
    super(props);
    this.state = { time: { hour: null, minute: null } };
  }
  componentWillMount() {
    var time: ITimeOfDay = {
      hour: this.props.time ? this.props.time.hour : null,
      minute: this.props.time ? this.props.time.minute : null
    };
    this.setState({ time });
  }
  hourChanged(hour: string) {
    var time: ITimeOfDay = { hour: parseInt(hour), minute: this.state.time.minute };
    this.setState({ time }, ()=>{
      this.updateTime();
    });
  }
  minuteChanged(minute: string) {
    var time: ITimeOfDay = { hour: this.state.time.hour, minute: parseInt(minute) };
    this.setState({ time }, ()=>{
      this.updateTime();
    });
  }
  updateTime(){
    if (this.props.onChange){
      this.props.onChange(this.state.time)
    }
  }
  componentWillReceiveProps(newProps: Props){
    if(newProps.time){
      let hour = this.state.time.hour;
      let minute = this.state.time.minute;
      let needsUpdate;
      if (newProps.time.hour !== this.state.time.hour){
        hour = newProps.time.hour;
        needsUpdate = true;
      }
      if (newProps.time.minute !== this.state.time.minute){
        minute = newProps.time.minute;
        needsUpdate = true;
      }
      if (needsUpdate){
        this.setState({ time: { hour, minute }})
      }
    }else{
      this.setState({ time: { hour: null, minute: null }})
    }
  }
  render() {
    var hours = _.range(0, 24, 1);
    var minutes = _.range(0, 60, 1);
    return <Grid className="time-picker">
      <Row>
        <Col verticalAlignment="center">
          <i className="icon icon-clock"/>
        </Col>
        <Col className="hour-col">
          <select className="hour" onChange={e => this.hourChanged(e.target.value)} value={this.state.time.hour != null ? this.state.time.hour.toString() : ""}>
            <option disabled={true} value="">HH</option>
            {hours.map(d => <option key={d.toString()} value={d.toString()}>{d < 10 ? `0${d}` : d}</option>) }
          </select>
        </Col>
        <Col className="time-colon" verticalAlignment="center">:</Col>
        <Col className="minute-col">
          <select className="minute" onChange={e => this.minuteChanged(e.target.value)} value={this.state.time.minute != null ? this.state.time.minute.toString() : ""}>
            <option disabled={true} value="">MM</option>
            {minutes.map(d => <option key={d.toString()} value={d.toString()}>{d < 10 ? `0${d}` : d}</option>) }
          </select>
        </Col>
      </Row>
    </Grid>
  }
}